<script>
   
    import { onMount, onDestroy, tick } from "svelte";
    
    export let isSoundReady;
    export let isPlayingMelody;
    export let isWatingForSound;
    export let fullscreen;
    export let onRealWeb;
    export let musiclist;
    export let hideSoundBar;
    
    
    let debugstring   = 'debug play 3 <br>';
    
    let soundElement;
    let currentSoundInterval = null;
    let currentMelody = '';
    let currentArtist = '';
    let currentIdx = '';
    let isPlayingSome = false;
    let volymeIsOn = true;
    export let showSoundBar = false;
    let lastPlaying = 1;

    let fadeinOngoing = false;



    
      
    for (let i = 0; i < 101; i++) {
    
        isPlayingMelody[i] = 0;
    }
    
  let marqueeWrapEl;   // "rutan" som klipper texten
  let marqueeTextEl;   // själva texten (för att mäta bredd)
  let soundItemEl;

  let marqueeDuration = 10; // sek (kommer räknas om)

  let ro;


    // kör när texten ändras + efter DOM uppdaterats
  $: if (currentArtist || currentMelody) {
    tick().then(() => computeMarquee());
  }


$: if (isPlayingSome && marqueeWrapEl) {
  const drift = Math.random() * -1.5; // mellan 0 och -1.5s
  marqueeWrapEl.style.setProperty("--vu-drift", `${drift}s`);
}



function computeMarquee() {

  if (!marqueeWrapEl || !marqueeTextEl) return;

  const wrapW = soundItemEl.clientWidth;
  const textW = marqueeTextEl.scrollWidth;



  // gap måste matcha CSS
  const gapPx = 48; // 3rem ≈ 48px

  // 🔥 exakt sträcka som ett segment behöver flyttas
  const distancePx = wrapW +textW + 48;

  // sätt CSS-variabel på marquee-elementet
  marqueeWrapEl.style.setProperty(
    "--marquee-distance",
    `${distancePx}px`
  );

    marqueeWrapEl.style.setProperty(
    "--marquee-text-length",
    `${textW }px`
  );

 
}
  


    const checkLoadStart = () => {
              soundElement.removeEventListener('loadstart', checkLoadStart);
              soundElement.load();
              soundElement.play();
              //console.log("Video loaded!");
    }

    const checkEnded = (idx) => {
              soundElement.removeEventListener('ended', checkEnded);
              soundElement.pause();
              soundElement.currentTime = 0.01;
              //soundElement.play();
              isPlayingSome = false;
              isPlayingMelody[idx] = 0 ;
              //console.log("Video loaded!");
    }

    const checkPlayTrough = (soundElement, resolve) => {
        soundElement.removeEventListener('canplaythrough', checkPlayTrough);
        isSoundReady = true;
        soundElement.pause();
        //console.log("Video loaded and ready to play!");
        resolve(); // Låt `await` fortsätta
    };

    const changeVideoSource = async (soundElement, newSrc) => {
    return new Promise((resolve, reject) => {
        // Ta bort eventuell tidigare lyssnare
        soundElement.removeEventListener('canplaythrough', checkPlayTrough);

        // Byt videons källa
        soundElement.src = newSrc;
        soundElement.load(); // Ladda om videon

        // Lägg till event listener
        const onCanPlayThrough = () => checkPlayTrough(soundElement, resolve);
        soundElement.addEventListener('canplaythrough', onCanPlayThrough);

        // Hantera fel vid videoladdning
        soundElement.onerror = () => reject(new Error("Error loading video"));
    });
};




    
    onMount(async() => {




          // Lista över alla Laddnings- och tillståndshändelser
          const loadAndStateEvents = [
              'loadstart',
              'progress',
              'suspend',
              'abort',
              'error',
              'stalled',
              'emptied',
              'loadedmetadata',
              'loadeddata',
              'canplay',
              'canplaythrough',
              'play',
              'playing',
              'pause',
              'ended',
              'seeked'
            ];
    
            // Lägg till event-lyssnare för varje event
            loadAndStateEvents.forEach(event => {
              soundElement.addEventListener(event, () => {
              });
            });
    
    }); // on mount














    
    // Funktion för att spela upp en specifik låt
    
    export const playMelody = (idx) => async () => {    
    //console.log('play melody' , idx);
    
    try {    
            lastPlaying = idx;
            isWatingForSound = idx;
    
            //console.log('PlayMelody ' +idx);
    
    
            let purl = musiclist[""+idx].preview_url;
    
            // if (!isSoundReady) return;
    
            showSoundBar = true;
    
            let temp  = isPlayingMelody[idx];
    
            // nollställ alla
            for (let i = 0; i < 101; i++) {
            isPlayingMelody[i] = 0;
            }
    
            /*
            0 = nollställd
            1 = spelar från noll
            2 = spelart från pause
            3 = paused
            */
    
            //console.log('play melody' , temp);
    
            if( temp === 0 ) {

                // byt låt
                //console.log('bytlåt');
                await changeVideoSource(soundElement, purl);
                const onCheckEnded = () => checkEnded(idx);
                //soundElement.addEventListener('ended', onCheckEnded );
                //console.log('bytlåt klar' + isSoundReady);
                if (!isSoundReady) return;
                //await delay(1000);
                //console.log('ta bort waiting' , isWatingForSound);

    
            isPlayingMelody[idx] = 1;
    
            } else if( temp === 1 ) {
    
            isPlayingMelody[idx] = 3;
    
            } else if( temp === 2 ){
    
            isPlayingMelody[idx] = 3;
    
            } else if( temp === 3 ){
    
            isPlayingMelody[idx] = 2;
    
            }
            isWatingForSound = 0;
    
    
            // Rensa tidigare interval om det finns
            if (currentSoundInterval) {
            clearInterval(currentSoundInterval);
            }
    
            soundElement.pause();
            isPlayingSome = false;
    
            if( isPlayingMelody[idx] === 1 || isPlayingMelody[idx] === 2 ){
    
                if( isPlayingMelody[idx] === 1 ) {
                    //soundElement.currentTime = song.start;
                    //soundElement.currentTime = 0;
                }
                //console.log('nu spelar vi');
                //fixSound(1);
                
                soundElement.play();
                soundElement.muted = false;
                fixSound(1);
                isPlayingSome = true;
                currentMelody = musiclist[""+idx].Titel;
                currentArtist = musiclist[""+idx].Artist;
                currentIdx = ""+idx;
    
                /*
                // Stoppar videon när den specifika låten nått sitt slut
                currentSoundInterval = setInterval(() => {
                    if (soundElement.currentTime >= song.end) {
                        soundElement.pause();
                        isPlayingSome = false;
                        isPlayingMelody[idx] = 0 ;
                        clearInterval(currentSoundInterval);
                    }
                }, 500);
                */
            }
        } catch (error) {
    
            console.error('Error in playMelody:', error);
        }
    
    }
    
    
    function playCurrentMelody() {
    
    let tmp = lastPlaying;
    
    for (let i = 0; i < 101; i++) {
      if(isPlayingMelody[i] != 0) {
        tmp = i;
      } 
    }
    
        //console.log(isPlayingMelody[tmp]);
        playMelody(tmp)();
    }
    
    function fixSound(f) {

      if(!fadeinOngoing ){
    
      if(f === 0 ){
        volymeIsOn = false;
      } else { 
        volymeIsOn = true;
      }
      
        

        if(f === 0){
          soundElement.muted = true;
        } else {
          fadeInAudio(soundElement, 2500, 0.2);
        }
    }
    
    }
    function fadeInAudio(audioElement, duration, targetVolume) {

      

      let interval = null;

      if(volymeIsOn) {
        fadeinOngoing = true;
        let step = 50; // Uppdatera var 50:e millisekund
        let volumeStep = targetVolume / (duration / step); // Hur mycket vi ska öka volymen per steg

        
        audioElement.muted = false; // Se till att ljudet är på
        audioElement.volume = 0.1; // Starta med volym 0

        interval = setInterval(() => {
            if (audioElement.volume < targetVolume) {
                audioElement.volume = Math.min(audioElement.volume + volumeStep, targetVolume); // Öka volymen
            } else {
              //console.log(audioElement.volume);
                clearInterval(interval); // Sluta när vi nått targetVolume
                //console.log('full volym2');
                audioElement.muted = false;
                audioElement.volume = targetVolume; // Starta med volym 0
                 // Se till att ljudet är på
                // debugstring = `${debugstring}  <span>fullvolym: ${targetVolume} </span><br>`;
                fadeinOngoing = false;
            }
        }, step);

      } else {

        clearInterval(interval);
        

      }
    }

    function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
    }
    </script>
    
    <style global type="text/scss" lang="scss">

/* ==========================================================================
   SOUND BAR / PLAYER UI
   - Steg 1: bara städa syntax, gruppera, kommentera (inga klassbyten/rename)
   ========================================================================== */

.soundContainer {
  position: relative;
  margin: 0 auto;
  bottom: 0;
  left: 0;
  right: 0;

  width: 100%;
  height: unset;

  background: transparent;

  /* default: hidden */
  display: none;

  justify-content: center;
  align-items: center;

  z-index: 1;

  &.showSoundBar {
    display: flex;
  }

  &.hideSoundBar {
    display: none;
  }
}


/* ==========================================================================
   Outer wrappers
   ========================================================================== */

.soundOuther {
  position: relative;
  width: 100%;
  margin: 0;
  box-sizing: border-box;
  background-color: transparent;
  padding: 1rem 0.5rem 1.5rem; /* top | sides | bottom */
  transition: all 0.9s ease-in-out;
}

.soundColorBox {
  position: relative;
  width: 100%;
  margin: 0;
  padding: 0;

  display: flex;
  flex-direction: row;
  justify-content: space-between;

  align-content: flex-start;
  align-items: flex-start;

  box-sizing: border-box;

  background-color: var(--bg-color-sound-box);
  color: var(--text-color-sound-box);

  border-radius: 2px;
  border: 1px solid #ddd;

  margin-top: 0;
}

/* ==========================================================================
   Buttons row
   - Hidden by default, shown via .showplayer
   - Toggles visuals via .isPlaying / .soundOn
   ========================================================================== */

.soundButtons {
  position: relative;
  width: 100%;
  margin: 0;
  margin-top: 0;
  padding: 0 1rem;

  display: none;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  gap: 2rem;

  height: var(--mellody-button-height);
  box-sizing: border-box;

  background-color: transparent;

  /* When playing: show pause, hide play */
  &.isPlaying {
    .buttonPlay {
      display: none;
    }
    .buttonPause {
      display: flex;
    }
  }

  /* Show player row */
  &.showplayer {
    display: flex;
  }

  /* "Sound on" state toggles the two volume buttons */
  &.soundOn {
    .soundButtonP {
      display: none;
    }
    .soundButtonPa {
      display: flex;
    }
  }
}

/* ==========================================================================
   Round icon buttons (sound on/off)
   ========================================================================== */

.soundButtonP,
.soundButtonPa {
  position: relative;

  width: 2.8rem;
  height: 2.8rem;

  border-radius: 50%;
  background-color: #fff;

  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;

  box-shadow: 0 0.01em 0.4em rgba(0, 0, 0, 0.2);
}

.soundButtonPa {
  display: none; /* toggled on via .soundButtons.soundOn */
}

/* ==========================================================================
   Spotify link + logo
   ========================================================================== */

.spotifyButton {
  position: absolute;
  right: 1%;

  width: 3.2rem;
  height: 3.2rem;
}

.spotifyText {
  position: absolute;
  right: 1%;
  bottom: -1.6rem;

  color: #616161;
  font-size: 0.9rem;
}

.logo {
  position: absolute;
  inset: 0; /* left:0; top:0; width/height:100% */

  width: 100%;
  height: 100%;
}

/* ==========================================================================
   Track label + equalizer
   ========================================================================== */

.soundItemWrapper {
  position: relative;
  width: 60%;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: center;

  box-sizing: border-box;

  background-color: #b7b7ab;
  color: #000;

  height: 70%;
  padding: 0.3rem;
  border-radius: 4px;
}

.soundItem {
  position: relative;
  font-size: 1.1rem;
  line-height: 1;
  width: 100%;
  overflow: hidden;
}

.equalizer {
  position: relative;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;

  z-index: 2;
  bottom: 0;
  right: 0;

  width: unset;

  visibility: hidden;

  &.showEq {
    visibility: visible;
  }
}

.eq {
  width: 1.8rem;
}

/* ==========================================================================
   SVG icons sizing
   ========================================================================== */



.XsvgIcon {
  width: 60%;
  height: 60%;

  fill: rgb(0, 0, 0);

  margin-left: 5px;
  margin-top: 1px;
}

.XsvgIconP {
  width: 60%;
  height: 60%;

  fill: rgb(0, 0, 0);

  margin-left: 0;
  margin-top: 0;
}



/* ==========================================================================
   Pause button (white round) + bars
   ========================================================================== */

.pause-button-white {
  position: relative;

  width: 4em;
  height: 4em;

  background-color: var(--bg-color-play-white);
  border-radius: 50%;

  display: flex;
  justify-content: center;
  align-items: center;

  box-shadow: 0 0.01em 0.4em rgba(0, 0, 0, 0.2);
  gap: 0.2rem;

  div.p1,
  div.p2 {
    width: 0.8em;
    height: 2.6em;

    background-color: #333;
  }

  div.p2 {
    border-radius: 0.1em;
  }
}








/* ==========================================================================
   Seamless marquee (A -> B -> A)
   - Alltid scroll
   - Texten startar vid HÖGERKANTEN i rutan
   ========================================================================== */

.marquee {
  width: var(--marquee-distance);
  white-space: nowrap;
}

.marquee__track {
  display: flex;
  align-items: center;
  transform: translateX(calc(-1 * var(--marquee-distance) + var(--marquee-text-length) ));

  /* gap mellan looparna */
  --marquee-gap: 3rem;

  /* tempo */
  --marquee-duration: 6s;

  will-change: transform;
}

.marquee__segment {
  flex: 0 0 auto;
  min-width: 100%;
  padding-right: var(--marquee-gap);

  /* 🔥 det här är nyckeln */
  display: flex;
  justify-content: flex-end; /* texten ligger vid högerkant */
}

/* själva texten */
.marquee__content {
  white-space: nowrap;
}

/* animate endast när playing */
.marquee.isScrolling .marquee__track {
  animation: marquee-loop var(--marquee-duration) linear infinite;
}


@keyframes marquee-loop {
  from { transform: translateX(0); }
  to   { transform: translateX(calc(-1 * var(--marquee-distance))); }
}



@media (prefers-reduced-motion: reduce) {
  .marquee.isScrolling .marquee__track {
    animation: none;
  }
}














.soundItemWrapper {
  position: relative;
  overflow: hidden; /* viktigt så glöden håller sig i rutan */
}

/* Diffus “VU-glow” som kommer inifrån */
.soundItemWrapper::before {
  content: "";
  position: absolute;
  inset: -40px;          /* gör fläcken större än rutan */
  pointer-events: none;
  opacity: 0;

  /* Den här gradienten ger “osynlig lampa” */
  background:
    radial-gradient(
      circle at 18% 50%,              /* var glöden sitter */
      rgba(255, 214, 107, 0.55) 0%,
      rgba(255, 214, 107, 0.25) 22%,
      rgba(255, 214, 107, 0.12) 42%,
      rgba(255, 214, 107, 0.00) 70%
    );

  filter: blur(10px);
  transform: scale(1.05);
}

/* Tänd när det spelar */
.soundButtons.isPlaying .soundItemWrapper::before {
  animation-delay: var(--vu-drift, 0s);
  opacity: 1;
  animation: vuGlow 12.6s ease-in-out infinite;
}

/* Mjuk puls (inte punkt) */
@keyframes vuGlow {
  0%   { opacity: 0.35; filter: blur(14px); transform: scale(1.02); }
  18%  { opacity: 0.72; filter: blur(18px); transform: scale(1.06); }
  31%  { opacity: 0.48; filter: blur(15px); transform: scale(1.04); }
  52%  { opacity: 0.88; filter: blur(20px); transform: scale(1.10); }
  67%  { opacity: 0.55; filter: blur(16px); transform: scale(1.05); }
  83%  { opacity: 0.76; filter: blur(19px); transform: scale(1.08); }
  100% { opacity: 0.40; filter: blur(14px); transform: scale(1.02); }
}

@keyframes vuGlow2{
  0%   { opacity: 0.22; filter: blur(14px); transform: scale(1.02); }
  18%  { opacity: 0.40; filter: blur(16px); transform: scale(1.04); }
  36%  { opacity: 0.30; filter: blur(15px); transform: scale(1.03); }
  55%  { opacity: 0.52; filter: blur(18px); transform: scale(1.06); }
  72%  { opacity: 0.34; filter: blur(15px); transform: scale(1.04); }
  88%  { opacity: 0.46; filter: blur(17px); transform: scale(1.05); }
  100% { opacity: 0.24; filter: blur(14px); transform: scale(1.02); }
}

/* Respektera reduced motion */
@media (prefers-reduced-motion: reduce) {
  .soundButtons.isPlaying .soundItemWrapper::before {
    animation: none;
    opacity: 0.75;
  }
}

/* ==========================================================================
   Debug
   ========================================================================== */

.debugger {
  display: none;
}

/* ==========================================================================
   Responsive tweaks
   ========================================================================== */

@media screen and (min-width: 519px) {
  .soundButtonP,
  .soundButtonPa {
    width: 3.2rem;
    height: 3.2rem;
  }

  .pause-button-white {
    width: 6em;
    height: 6em;
    font-size: 0.53rem;
  }
}


    </style>
    
    <div class="soundContainer" class:showSoundBar={showSoundBar} class:hideSoundBar={hideSoundBar} >
    <div class="soundOuther">  
        <div class="soundColorBox">
            <audio id="sound" bind:this={soundElement} preload="auto" muted playsinline loop> <track kind="captions"> 
                <source src="https://p.scdn.co/mp3-preview/fd3fe4e6c57fa634e21292e084110da387fe3a21" type="audio/mpeg">
                <p>Din webbläsare stödjer inte video. Vänligen uppdatera till en modern webbläsare.</p>
            </audio>
                <div class="soundButtons showplayer " class:isPlaying={isPlayingSome}  class:soundOn={volymeIsOn} >
                <div class="soundItemWrapper">
                   
                    <div class="soundItem" bind:this={soundItemEl}>
                      <div
                        class="marquee"
                        bind:this={marqueeWrapEl}
                        class:isScrolling={isPlayingSome}>
                        
                        <div class="marquee__track">
                        <span class="marquee__segment">
                          <span class="marquee__content" bind:this={marqueeTextEl}>
                            <b>{currentArtist}</b>{` - ${currentMelody}`}
                          </span>
                        </span>
                        </div>
                      </div>
                    </div>
                    
                </div> 
                <div class="buttonPlay" on:click={() => playCurrentMelody()} on:keydown={() => playCurrentMelody()}><div class="play-button-white"></div></div>
                <div class="buttonPause" on:click={() => playCurrentMelody()} on:keydown={() => playCurrentMelody()}><div class="pause-button-white"><svg class="XsvgIconP"><use xlink:href='./local_assets/melloCharts/icons/icons.svg#ds-pause'/></svg></div></div>
                <div class="soundButtonP" on:click={() => fixSound(1)} on:keydown={() => fixSound(1)}><svg class="XsvgIcon"><use xlink:href='./local_assets/melloCharts/icons/icons.svg#ljud_on'/></svg></div><div class="soundButtonPa" on:click={() => fixSound(0)} on:keydown={() => fixSound(0)}><svg class="XsvgIconP"><use xlink:href='./local_assets/melloCharts/icons/icons.svg#ljud_off'/></svg></div>
                <div class="spotifyText"><span> <a href="https://open.spotify.com/user/dagensnyheter?si=d8820f1782ec4ada">Lyssna på hela låten på Spotify</a></span></div>
                <div class="verticaldivider"></div>  
                <div class="spotifyButton"><a href="https://open.spotify.com/user/dagensnyheter?si=d8820f1782ec4ada"><img class="logo"  alt="logo" src="local_assets/musicLongChart/images/logo.png" /></a></div>
                
                </div>  
        </div>
    </div>
   
    </div>
    <div class="debugger">{@html debugstring}</div>